<link rel="stylesheet" href="clients-comparator-table.component.scss">
<ag-grid-angular
  [style.height.px]="45 + 30 * 10 + 11"
  [class]="'ag-theme-alpine'"
  [rowData]="rowData"
  [columnDefs]="colDefs"
  [gridOptions]="gridOptions"
  [context]="context"
  (gridReady)="gridApi = $event.api"
  (columnResized)="columnResize$.emit()"
/>

<div class="flex-row" style="flex-wrap: wrap; gap: 0.5rem; padding: 0.5rem;">
  <button
    mat-raised-button color="accent"
    [disabled]="context.selectedHeader == null || context.selectedHeader.getColDef().pinned === 'left'"
    class="action-button"
    (click)="onTakeData()"
  >
    Daten übernehmen
  </button>

  <button
    mat-raised-button color="accent"
    class="action-button"
    (click)="getMoreClients()"
  >
    mehr anzeigen
  </button>

  <button
    mat-raised-button color="accent"
    [disabled]="!(context.selectedHeader == null || context.selectedHeader.getColDef().pinned === 'left')"
    class="action-button"
    (click)="onSeparateClientReference.emit()"
  >
    Patientenreferenz aufheben
  </button>
</div>
